"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFrameDialog = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _iframeResizerReact = _interopRequireDefault(require("iframe-resizer-react"));
var _propTypes = require("prop-types");
var _InfoDialog = _interopRequireDefault(require("@rio-cloud/rio-uikit/lib/es/InfoDialog"));
var _Spinner = _interopRequireDefault(require("@rio-cloud/rio-uikit/lib/es/Spinner"));
var _lib = require("../../lib");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var IFrameDialog = function IFrameDialog(props) {
  var show = props.show,
    onClose = props.onClose,
    contentUrl = props.contentUrl,
    openTabIndex = props.openTabIndex;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var updatedOnClose = function updatedOnClose() {
    onClose();
    setIsLoading(true);
  };
  var onIframeMessage = function onIframeMessage(event) {
    var messageOrigin = event.iframe.src.replace(/\/$/, ''); // remove trailing slash from src
    if (messageOrigin.startsWith("".concat(contentUrl, "/#showNewSettingsDialog"))) {
      var message = event.message;
      switch (message.type) {
        case 'IFRAME_CLOSE_DIALOG':
          updatedOnClose();
          break;
        case 'IFRAME_LANGUAGE_CHANGED':
          document.dispatchEvent(new CustomEvent(_lib.EVENT_USER_LANGUAGE_CHANGED, {
            detail: {
              language: message.locale ? message.locale : 'en-GB'
            }
          }));
          break;
        case 'IFRAME_PROFILE_CHANGED':
          document.dispatchEvent(new CustomEvent(_lib.EVENT_USER_PROFILE_CHANGED, {
            detail: message.user ? message.user : {
              firstName: '',
              lastName: '',
              username: ''
            }
          }));
          break;
        default:
          break;
      }
    }
  };
  var renderHTMLFrame = function renderHTMLFrame() {
    var iframe = /*#__PURE__*/_react.default.createElement("div", {
      className: 'padding-left-0'
    }, isLoading && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        height: '50px',
        alignItems: 'flex-end'
      }
    }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      isDoubleSized: true
    })), /*#__PURE__*/_react.default.createElement(_iframeResizerReact.default, {
      id: 'settingsdialog-iframe',
      heightCalculationMethod: "lowestElement",
      inPageLinks: true,
      minHeight: 300,
      maxHeight: 520 // required to stop dropdown from enlarging the window
      ,
      onInit: function onInit() {
        return setIsLoading(false);
      },
      onMessage: function onMessage(evt) {
        return onIframeMessage(evt);
      },
      src: "".concat(contentUrl, "/#showNewSettingsDialog").concat(openTabIndex ? '?tab=' + openTabIndex : ''),
      className: 'margin-top--10 margin-bottom--20',
      style: {
        width: '1px',
        minWidth: '100%',
        border: '0'
      }
    }));
    return /*#__PURE__*/_react.default.createElement(_InfoDialog.default, {
      show: show,
      content: iframe,
      className: 'DialogModal'
    });
  };
  if (show) {
    return renderHTMLFrame();
  }
  return null;
};
exports.IFrameDialog = IFrameDialog;
IFrameDialog.propTypes = {
  show: _propTypes.PropTypes.bool,
  onClose: _propTypes.PropTypes.func,
  contentUrl: _propTypes.PropTypes.string,
  openTabIndex: _propTypes.PropTypes.number
};